import { CampaignProcess } from 'utils/constants/campaign';

import { selectCampaignProcess } from 'store/models/createCampaign';
import { useSelector } from 'store/utils';

const useIsEditCampaign = (): boolean => {
    const campaignProcess = useSelector(selectCampaignProcess);

    return campaignProcess === CampaignProcess.Edit;
};

export default useIsEditCampaign;
